import React, {useEffect, useState} from 'react';
import {ProjectJson} from "../../api/json/ProjectJson"
import ApiError from "../../api/ApiError"
import {Button, Modal, Stack, Typography} from "@mui/material"
import modalStyles from "../modal/Modal.module.scss"
import ColumnOrderList from "./ColumnOrderList"
import {AnyColumnJson} from "../../api/json/ColumnJson"
import {ColumnRequests} from "../../api/requests/ColumnRequests"
import AsyncButton from "../button/AsyncButton"
import ErrorMessage from "../error/ErrorMessage"

function ColumnOrderModal({project, columns, open, onClose}: {project: ProjectJson, columns: AnyColumnJson[], open: boolean, onClose: () => void}) {
    const [modified, setModified] = useState<AnyColumnJson[]>([])

    const [error, setError] = useState<ApiError>()
    const [saveFinishedCount, setSaveFinishedCount] = useState<number>(0)
    const [saveInProgress, setSaveInProgress] = useState(false)

    const handleSave = () => {
        setError(undefined)
        setSaveInProgress(true)
        setSaveFinishedCount(0)
        modified.forEach(column => {
            ColumnRequests.update(project.id, column.id!, undefined, undefined, column.order)
                .then()
                .catch(setError)
                .finally(() => setSaveFinishedCount(prev => prev + 1))
        })
    }

    const updateFields = (updatedFields: AnyColumnJson[]) => {
        let newState = [...modified]
        updatedFields.forEach(updatedField => {
            let index = newState.findIndex( existing => existing.id === updatedField.id)
            if (index === -1) {
                newState.push(updatedField)
            } else {
                newState[index] = updatedField
            }
        })
        setModified(newState)
    }

    useEffect(() => {
        if (saveFinishedCount === modified.length) {
            setSaveInProgress(false)
            if (!error) {
                onClose()
            }
        }
    }, [saveFinishedCount])

    return (
        <Modal
            open={open}
            onClose={onClose}
        >
            <div className={modalStyles.flexCenteredModalContainer}>
                <Stack spacing={2} className={modalStyles.fieldOrderModal}>
                    <Typography variant="h2">Order Columns</Typography>
                    <Typography>Set the order in which columns should be displayed.</Typography>

                    <ColumnOrderList columns={columns}
                                    onChange={updateFields}
                                    sx={{mt:2}}/>

                    <Stack direction="row" alignSelf="flex-end" justifyContent="flex-end" spacing={2}>
                        <Button variant="contained" color="info" onClick={onClose}>
                            Cancel
                        </Button>
                        <AsyncButton variant="contained"
                                     waiting={saveInProgress}
                                     onClick={handleSave} sx={{flex: 1}}>
                            Save & close
                        </AsyncButton>
                    </Stack>
                    {error && <ErrorMessage error={error}/> }
                </Stack>
            </div>
        </Modal>
    );
}

export default ColumnOrderModal;